import { Component, OnInit } from '@angular/core';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Editor } from 'ngx-editor';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { SettingForm } from '../../../../../core/request-forms/SettingForm';
import { FileService } from '../../../../../core/services/file.service';
import { RoleService } from '../../../../../core/services/role.service';
import { SettingService } from '../../../../../core/services/setting.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { FormsModule } from '@angular/forms';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxPaginationModule } from 'ngx-pagination';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../../layout/includes/header/header.component';

@Component({
    selector: 'app-setting',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, NgxPaginationModule,],
    templateUrl: './setting.component.html',
    styleUrls: ['./setting.component.css']
})
export class SettingComponent implements OnInit {

  fileSrc:any="https://placehold.co/200x200"
  loading=false
  fileInput:any
  editor: Editor | undefined;
  data=SettingForm
  isNew=true
  roles:any[]=[]
  tag="admin-settings"

  constructor(
    private spinnerService:NgxSpinnerService,
    private fileService:FileService,
    private roleService:RoleService,
    private settingService:SettingService,
    private toastrService:ToastrService,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }

  ngOnInit(): void {
      this.editor = new Editor();
      this.getRoles()
      this.getOne()

  }

  getRoles(){
    this.roleService.getAll().subscribe((res:any)=>{
      this.roles=res.data
    },
    (err:any)=>{
    AppErrorShow.showError("Gestion des utilisateurs",err)
    })
  }

getOne(){
  this.settingService.getAll().subscribe((res:any)=>{
    if (res.data!=null) {
      this.data.id=res.data.id
      this.data.director_name=res.data.director_name
      this.data.director_phone=res.data.director_phone
      this.data.signature=res.data.signature
      this.data.school_id=res.data.school_id
      this.data.role_for_professor=parseInt(res.data.role_for_professor)
      this.data.role_for_student=parseInt(res.data.role_for_student)
      this.data.role_for_parent=parseInt(res.data.role_for_parent)
      this.fileSrc=this.data.signature
      //this.getFile('local','director',res.data.signature)
      this.isNew=false
    }
    this.modalService.dismissAll()
  },
  (err:any)=>{
    AppErrorShow.showError("Gestion des paramètres",err)

  })

}
  getFile(disk:any,folder:any,filename:any){
    //this.pdfViewLoader=true
    this.spinnerService.show()
    this.fileService.get({
      folder:folder,
      disk:disk,
      filename:filename
    }).subscribe((res:any)=>{
     // this.pdfViewLoader=false
     this.spinnerService.hide()
      this.fileSrc=res[0]
     // this.offcanvasService.open(this.contentPDF,{  panelClass: 'details-panel', position: 'end'  });
      this.spinnerService.hide()
    },
    (err:any)=>{
      this.spinnerService.hide()

AppErrorShow.showError("Gestion des paramètres",err)
    })
  }



  setData(value:any){
    let formData= new FormData()

    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        const element = value[key];
          formData.append(key,element)
      }
    }

    if (this.fileInput!=undefined) {
      formData.append("signature",this.fileInput)
    }
    if (this.isNew) {
      this.loading=true
      this.settingService.store(formData).subscribe((res:any)=>{
        //this.data=res.data
        this.loading=false
        this.toastrService.info("Donnée de l'établissement mis à jour")
      },
      (err:any)=>{
        this.loading=false
        AppErrorShow.showError("Gestion des paramètres",err)
      })
    } else {
      this.loading=true

      this.settingService.update(this.data.id,formData).subscribe((res:any)=>{
        //this.data=res.data
        this.loading=false
        this.toastrService.info("Donnée de l'établissement mis à jour")
      },
      (err:any)=>{
        this.loading=false
        AppErrorShow.showError("Gestion des paramètres",err)

      })
    }
  }

  readFile(){
    var reader = new FileReader();

    reader.readAsDataURL(this.fileInput); // read file as data url

    reader.onload = (event) => { // called once readAsDataURL is completed
      this.fileSrc = event.target?.result;
    }
  }

  loadImg(event:any){
    if(event.target.files.length!=0){
      this.fileInput=event.target.files[0]
      this.readFile()
    }
  }

  ngOnDestroy(): void {
    this.editor?.destroy();
  }

}
